<div class="mat-sz-rt">
  <div class="mat-sz-avt">
    <img [src]="productImage" />
  </div>
  <div class="mat-sz-ct">
    <div class="mat-sz-inr">
      <h4>{{item.DesignName}} &nbsp;<span class="text-info">({{item.CustomizationType }})</span></h4>
      <div class="st-row">
        <div class="strng-col">Color: <strong>{{item.ColorName}}</strong></div>
        <div class="strng-col">Size: <strong>{{item.SizeName }}</strong></div>
        <div class="strng-col">
          Price: <strong>{{item.TotalPrice  | currency:'USD':'symbol':'1.2-2'}} </strong><span> per piece</span>
        </div>
        <!--<div class="strng-col" *ngIf="userRole=='StoreAdmin'">
      Price: <strong>{{item.UnitPrice  + ((item.ProductSidesCount-1) * item.PrintingCost) | currency:'USD':'symbol':'1.2-2'}} </strong><span> per piece</span>
    </div>-->
      </div>
    </div>

    <div class="mt-qt">
      <div class="input-group">
        <strong>Qty</strong>
        <button *ngIf="item.Quantity>1" mat-icon-button (click)="fn_UpdateQty.emit({id:item.CartItemId,order: 'DEC'})">
          <mat-icon>remove</mat-icon>
        </button>
        <span>{{item.Quantity}}</span>
        <button mat-icon-button (click)="fn_UpdateQty.emit({id:item.CartItemId, order:'INC'})">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="cstm-lbl-rd">
      <div class="lt-us-rmb">
        <a *ngIf="sampleOrderForStoreAdmin==='0'&& (userRole=='EndUser')" class="mat-scss" (click)="fn_MoveToWishList.emit(item.CartItemId)">
          Move to wishlist
        </a>
        <a class="mat-warn" (click)="fn_RemoveCartitem.emit(item.CartItemId)">
          Remove
        </a>
      </div>
    </div>
    <div *ngIf="item.Message && item.Message!=''">
      <span *ngIf="item.StockOnHand>0" class="text-danger">{{item.Message}}</span>
      <span *ngIf="item.StockOnHand ==0" class="text-danger">Currently No Stock available</span>
    </div><br/><br/>
  </div>
</div>
